import { render, staticRenderFns } from "./TextSpeak.vue?vue&type=template&id=26150f70&scoped=true&"
import script from "./TextSpeak.vue?vue&type=script&lang=js&"
export * from "./TextSpeak.vue?vue&type=script&lang=js&"
import style0 from "./TextSpeak.vue?vue&type=style&index=0&id=26150f70&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26150f70",
  null
  
)

export default component.exports